export default __webpack_public_path__ + "static/media/vision.2b845342.ico";